import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  progress: number; // 0 to 100
  label?: string;
}
export const ProgressBar = ({
  progress,
  label
}: ProgressBarProps) => {
  return <div className="w-full flex flex-col items-center gap-3 my-6" data-id="element-288">
      {label && <span className="font-sans uppercase" style={{
      color: '#b8923d',
      fontSize: '11.5px',
      letterSpacing: '0.18em',
      fontWeight: 500
    }} data-id="element-289">
          {label}
        </span>}
      <div className="relative w-full max-w-md h-[2px] bg-ink-light rounded-full overflow-visible" data-id="element-290">
        {/* Background track glow */}
        <div className="absolute inset-0 bg-gold/5 blur-sm rounded-full" data-id="element-291" />

        {/* Animated Fill */}
        <motion.div className="absolute top-0 left-0 h-full bg-gradient-to-r from-bronze via-gold to-gold-light shadow-gold-glow" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.8,
        ease: 'easeInOut'
      }} data-id="element-292">
          {/* Glowing tip */}
          <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 bg-white rounded-full shadow-[0_0_10px_#c9a961,0_0_20px_#e5c78b] blur-[1px]" data-id="element-293" />
        </motion.div>
      </div>
      <span className="font-eb text-parchment/50 text-xs italic" data-id="element-294">
        {Math.round(progress)}% Completado
      </span>
    </div>;
};